import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { X } from "lucide-react";
import popupAsset from "@/assets/happy-hour-popup.jpg.asset.json";

const STORAGE_KEY = "cavalli:happy-hour-count";
const MAX_SHOWS = 3;
const DELAY_MS_EARLY = 20000;
const DELAY_MS_LATE = 5000;
const SWITCH_DATE = new Date("2026-09-29T00:00:00+03:00").getTime();

const getCount = () => {
  const v = sessionStorage.getItem(STORAGE_KEY);
  return v ? parseInt(v, 10) : 0;
};

const bumpCount = () => {
  sessionStorage.setItem(STORAGE_KEY, String(getCount() + 1));
};

const HappyHourPopup = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (getCount() >= MAX_SHOWS) return;

    const delay = Date.now() >= SWITCH_DATE ? DELAY_MS_LATE : DELAY_MS_EARLY;
    const t = setTimeout(() => {
      bumpCount();
      setOpen(true);
    }, delay);
    return () => clearTimeout(t);
  }, [location.pathname]);

  const close = () => setOpen(false);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[9998] flex items-center justify-center bg-black/70 backdrop-blur-sm animate-fade-in p-4"
      role="dialog"
      aria-modal="true"
      aria-label="Happy Hour"
      onClick={close}
    >
      <div
        className="relative max-w-[92vw] max-h-[92vh] md:max-w-[600px] md:max-h-[85vh]"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          onClick={close}
          aria-label="סגור"
          className="absolute top-2 z-10 w-10 h-10 rounded-full bg-background/90 border border-primary/50 text-primary flex items-center justify-center shadow-lg hover:scale-105 transition-transform"
          style={{ right: "0.5rem", left: "auto" }}
        >
          <X className="w-5 h-5" />
        </button>
        <img
          src={popupAsset.url}
          alt="Happy Hour בקפה קוואלי - 1+1 על תפריט קוקטיילים, 15:00-18:00 בכל יום"
          className="block max-w-full max-h-[92vh] md:max-h-[85vh] w-auto h-auto rounded-lg shadow-2xl"
          loading="eager"
          decoding="async"
        />
      </div>
    </div>
  );
};

export default HappyHourPopup;
